module.exports = __webpack_public_path__ + "static/media/product_2@3x.9bd91090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/early_access/product_2/product_2@3x.png
// module id = 68
// module chunks = 0